import { render, staticRenderFns } from "./next_order.vue?vue&type=template&id=10334641&"
import script from "./next_order.vue?vue&type=script&lang=js&"
export * from "./next_order.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports